export class LOGIN {
    static readonly LOGIN_URL = "v2/account/login";
    static readonly REFRESH_TOKEN_URL = "v2/account/refresh-access-token";
}